import Persistence from "../persistence";

export const LOCAL_LOGIN_START = "auth/LOCAL_LOGIN_START";
export const LOADED_EXPERIMENTAL_FEATURES = "auth/LOADED_EXPERIMENTAL_FEATURES";

type UserType = ReturnType<typeof Persistence.getCurrentUser>;

export const localLoginStart = (currentUser: UserType) => ({
  type: LOCAL_LOGIN_START,
  payload: currentUser,
});

export const loadedExperimentalFeatures = (features: { [key: string]: any }[]) => ({
  type: LOADED_EXPERIMENTAL_FEATURES,
  payload: features
});